
(function() {
  var result = { translations: { "pt-br": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m", "days": "{{ days }} dias", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ramal {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "pt-br": "static-7.1203"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1203",
    "ar-eg": "static-7.1203",
    "bg": "static-7.1203",
    "bn": "static-7.1203",
    "ca-es": "static-7.1203",
    "cs": "static-7.1203",
    "da": "static-7.1203",
    "de": "static-7.1203",
    "el": "static-7.1203",
    "en-gb": "static-7.1203",
    "en": "static-7.1203",
    "es-mx": "static-7.1203",
    "es": "static-7.1203",
    "et": "static-7.1203",
    "fi": "static-7.1203",
    "fr-ca": "static-7.1203",
    "fr": "static-7.1203",
    "he-il": "static-7.1203",
    "hi": "static-7.1203",
    "hr": "static-7.1203",
    "hu": "static-7.1203",
    "id": "static-7.1203",
    "it": "static-7.1203",
    "ja": "static-7.1203",
    "ko": "static-7.1203",
    "lt": "static-7.1203",
    "ms": "static-7.1203",
    "nl": "static-7.1203",
    "no": "static-7.1203",
    "pl": "static-7.1203",
    "pt-br": "static-7.1203",
    "pt-pt": "static-7.1203",
    "ro": "static-7.1203",
    "ru": "static-7.1203",
    "sk": "static-7.1203",
    "sl": "static-7.1203",
    "sv": "static-7.1203",
    "th": "static-7.1203",
    "tl": "static-7.1203",
    "tr": "static-7.1203",
    "uk": "static-7.1203",
    "vi": "static-7.1203",
    "x-pseudo": "static-7.1203",
    "zh-cn": "static-7.1203",
    "zh-hk": "static-7.1203",
    "zh-tw": "static-7.1203"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pt-br', {version: 'static-7.1203'}); }
})();


